import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../shared/user.service';
import { User } from '../../shared/user.model';

@Component({
  selector: 'app-usuario-edicion',
  templateUrl: './usuario-edicion.component.html',
  styleUrls: ['./usuario-edicion.component.css']
})
export class UsuarioEdicionComponent implements OnInit {

  user: User;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  errors: string[];

  constructor(private userService: UserService,
              private toastr: ToastrService,
              private router: Router) { }

  ngOnInit() {
    this.resetForm();
    this.errors = [];
  }

  resetForm(form?: NgForm) {
    // if (form != null) { form.reset(); }
    this.user = {
      UserName: '',
      ConfirmPassword: '',
      Password: '',
      Email: '',
      FirstName: '',
      LastName: '',
      Empresa: '',
      clienteID: 0,
    };
  }


  Guardar(form: any) {
    this.errors = [];
    Object.keys(form).forEach((key, index) =>
      this.user[key] = form[key]
    );
    this.userService.registerUser(this.user)
    .subscribe(res => {
      // console.log('Repuesta');
      // console.log(res);
      // if (res) {
      //    if (res.status === 200) {
            this.resetForm();
            this.toastr.success('¡Bienvenido al Espacio AMG!');
            this.router.navigate(['/login']);
      //    }
      // }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        if (err.status === 400) {
          // this.errors.push(err.error.Message);
          for (const key in err.error.ModelState) {
            if (err.error.ModelState.hasOwnProperty(key)) {
              const element = err.error.ModelState[key];
              this.errors.push(element);
            }
          }
        }  else {
          this.errors.push('Ocurrio un error al registrar el usuario.');
        }
      });
  }

  }





// WEBPACK FOOTER //
// ./src/app/user/usuario-edicion/usuario-edicion.component.ts